import { ReactNode } from 'react'
import * as styles from './input-group.css'

type InputGroupProps = {
  /** The child elements to be rendered with consistent spacing */
  children: ReactNode
  /** Optional title for the input group */
  title?: string
  /** Optional action element to display next to the title */
  titleAction?: ReactNode
}

export function InputGroup({ children, title, titleAction }: InputGroupProps) {
  return (
    <div className={styles.inputGroup}>
      {title && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <span className={styles.title}>{title}</span>
          {titleAction && <div className={styles.titleAction}>{titleAction}</div>}
        </div>
      )}
      {children}
    </div>
  )
}
